import React, { useState } from 'react'

const InternshipCloud = () => {
    const [activeTab, setActiveTab] = useState('basics'); // Default tab

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <section id="devops">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="text-purple">6-Month Cloud Computing Roadmap </h2>
                        <p className="fw-medium">(From Scratch to Expert)</p>
                    </div>
                </div>
                <div className="row my-5 devcontaint">
                    <div className="col-md-3 col-12">
                        <div className="left-side h-100 flex-md-row flex-column">
                            <ul className="d-md-block d-flex">
                                {/* Tab Buttons */}
                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'basics' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('basics')}
                                >
                                    <div className={`fs-1 image-section type2    ${activeTab === 'basics' ? '' : '  '}`}>
                                        1
                                    </div>
                                    <div className={`text-section d-md-inline ${activeTab === 'basics' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold" >Basics</h6>
                                    </div>
                                </li>

                                <li
                                    role='button' className={`d-flex flex-md-row flex-column ${activeTab === 'react' ? 'active ' : ''}`}
                                    onClick={() => handleTabClick('react')}
                                >
                                    <div className="image-section type2 fs-2">
                                        2
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'react' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Advanced Cloud</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'node-js' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('node-js')}
                                >
                                    <div className="image-section type2 fs-1">
                                        3
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'node-js' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Cloud Automation</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'MongoDB' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('MongoDB')}
                                >
                                    <div className="image-section type2 fs-1">
                                        4
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'MongoDB' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Cloud Architecture</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'full-stack' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('full-stack')}
                                >
                                    <div className="image-section type2 fs-1 ">
                                        5
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'full-stack' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Cloud Certification</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'interview-preparation' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('interview-preparation')}
                                >
                                    <div className="image-section type2 fs-1" >
                                        6
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'interview-preparation' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Interview preparations</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-9 col-12">
                        <div className="right-side">
                            {activeTab === 'basics' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Introduction to Cloud Computing and Core Concepts</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 1: Introduction to Cloud Computing</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 1-2: What is Cloud Computing? – </strong> Overview, Benefits, Types (public, private, hybrid).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 3-4: Cloud Service Models – </strong> IaaS (Infrastructure as a Service), PaaS (Platform as a Service), SaaS (Software as a Service).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 5-6: Deployment Models – </strong> Public Cloud, Private Cloud, Hybrid Cloud, Community Cloud.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 7: Test Day – </strong> Cloud Computing Basics Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 2: Cloud Architecture and Infrastructure</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 8-9: Cloud Architecture Overview – </strong> Components of Cloud (Compute, Storage, Network).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 10-11: Virtualization – </strong> Virtual Machines (VMs), Hypervisors, Virtualization vs Cloud Computing.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 12-13: Cloud Networking – </strong> Virtual Networks, Subnets, IP Addressing, DNS, Load Balancers.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 14: Test Day – </strong> Cloud Architecture and Networking Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 3: Cloud Computing Providers Overview</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 15-16: Introduction to AWS (Amazon Web Services) – </strong> Overview of AWS Cloud Services.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 17-18: Introduction to Microsoft Azure – </strong> Overview of Azure Services and Architecture.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 19-20: Introduction to Google Cloud Platform – </strong> Overview of Google Cloud Services.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 21: Test Day – </strong> Cloud Providers Overview Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 4: Cloud Storage and Data Management</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 22-23: Cloud Storage Overview – </strong> Types of Cloud Storage (Block, File, Object Storage).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 24-25: Data Management in Cloud – </strong> Databases as a Service (DBaaS), SQL vs NoSQL in the Cloud.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 26-27: Cloud Backup and Disaster Recovery – </strong> Backup Services, Data Replication, Failover.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 28: Test Day – </strong> Cloud Storage and Data Management Quiz.
                                        </li>
                                    </ul>
                                </div>

                            )}
                            {activeTab === 'react' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Advanced Cloud Concepts and Services</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 5: Compute Services in the Cloud</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 29-30: Compute Services Overview – </strong> EC2 (AWS), Virtual Machines (Azure, Google Cloud).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 31-32: Auto-Scaling – </strong> Horizontal and Vertical Scaling, Auto-Scaling Groups in AWS, VM Scale Sets in Azure.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 33-34: Containers – </strong> Introduction to Docker, Kubernetes, Container Orchestration.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 35: Test Day – </strong> Compute Services Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 6: Networking in the Cloud</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 36-37: Virtual Private Cloud (VPC) – </strong> Creating VPCs, Subnets, Security Groups, and Routing.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 38-39: Load Balancing – </strong> Application Load Balancer (ALB), Network Load Balancer (NLB) in AWS; Azure Load Balancer.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 40-41: VPN and Direct Connect – </strong> Site-to-Site VPN, Dedicated Connections, and Inter-Region Connectivity.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 42: Test Day – </strong> Cloud Networking Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 7: Cloud Databases</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 43-44: Database as a Service (DBaaS) – </strong> Amazon RDS, Azure SQL Database, Cloud Spanner (Google Cloud).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 45-46: NoSQL Databases – </strong> DynamoDB, CosmosDB, Cloud Datastore.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 47-48: Cloud Caching – </strong> Amazon ElastiCache, Azure Cache for Redis.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 49-50: Cloud Data Warehousing – </strong> Redshift, BigQuery, Azure Synapse Analytics.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 51: Test Day – </strong> Cloud Databases Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 8: Cloud Security and Compliance</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 52-53: Cloud Security Basics – </strong> Shared Responsibility Model, Identity and Access Management (IAM), Key Management.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 54-55: Security Services – </strong> AWS KMS, Azure Key Vault, Google Cloud Security.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 56-57: Compliance and Governance – </strong> GDPR, HIPAA, SOC-2, AWS Well-Architected Framework.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 58-59: Cloud Monitoring – </strong> CloudWatch, CloudTrail, Azure Monitor, Google Stackdriver.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 60: Test Day – </strong> Cloud Security and Compliance Quiz.
                                        </li>
                                    </ul>
                                </div>

                            )}
                            {activeTab === 'node-js' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Cloud Automation and Development</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 9: Introduction to Cloud DevOps</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 61-62: Cloud DevOps Overview – </strong> CI/CD (Continuous Integration and Continuous Deployment) in the cloud.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 63-64: Automation Tools – </strong> AWS CloudFormation, Azure Resource Manager (ARM), Google Cloud Deployment Manager.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 65-66: Infrastructure as Code (IaC) – </strong> Terraform, AWS CDK, Azure Bicep.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 67: Test Day – </strong> Cloud DevOps Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 10: Serverless Computing</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 68-69: Introduction to Serverless – </strong> Lambda (AWS), Azure Functions, Google Cloud Functions.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 70-71: Serverless Architecture – </strong> Event-driven, Stateless, Scalability.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 72-73: Serverless Databases – </strong> DynamoDB, CosmosDB, Firebase Realtime Database.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 74: Test Day – </strong> Serverless Computing Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 11: Cloud Analytics and Big Data</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 75-76: Cloud Analytics Overview – </strong> Data Lakes, Big Data Services.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 77-78: AWS Analytics Services – </strong> Amazon Redshift, Athena, EMR (Elastic MapReduce).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 79-80: Azure Big Data Services – </strong> Azure Databricks, Synapse Analytics.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 81: Test Day – </strong> Cloud Analytics and Big Data Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 12: Machine Learning and AI in Cloud</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 82-83: Introduction to AI and Machine Learning – </strong> Services like Amazon SageMaker, Azure AI, Google AI Platform.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 84-85: Data Pipelines for Machine Learning – </strong> Data Prep, Training, Testing, and Deployment in Cloud.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 86-87: Cloud AI Use Cases – </strong> Image Recognition, NLP, Recommender Systems.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 88-89: ML Integration with Cloud Services – </strong> IoT, Smart Devices, and Mobile Apps.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 90: Test Day – </strong> Cloud AI and ML Services Quiz.
                                        </li>
                                    </ul>
                                </div>

                            )}



                            {activeTab === 'MongoDB' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Cloud Architecture and Advanced Topics</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 13: Cloud Architecture Design</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 91-92: Cloud Design Principles – </strong> High Availability, Fault Tolerance, Scalability.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 93-94: Well-Architected Framework – </strong> Cost Optimization, Security, Reliability.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 95-96: Designing Multi-Tier Architectures – </strong> Load Balancing, Auto Scaling, Distributed Databases.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 97: Test Day – </strong> Cloud Architecture Design Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 14: Advanced Cloud Topics</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 98-99: Edge Computing – </strong> AWS Wavelength, Azure IoT Edge, Google Edge TPU.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 100-101: Cloud IoT Solutions – </strong> Connecting Devices to Cloud, Data Processing.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 102-103: Cloud Governance and Cost Management – </strong> AWS Cost Explorer, Azure Cost Management.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 104: Test Day – </strong> Advanced Cloud Topics Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 15: Cloud Migration Strategies</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 105-106: Cloud Migration Planning – </strong> Lift and Shift, Replatforming, Refactoring.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 107-108: Cloud Migration Tools – </strong> AWS Migration Hub, Azure Migrate, Google Cloud Migration Tools.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 109-110: Hybrid Cloud Solutions – </strong> Integrating On-premise with Cloud.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 111: Test Day – </strong> Cloud Migration Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 16: Cloud Project Implementation</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 112-113: Build a Cloud-based Web App – </strong> Choose a platform (AWS, Azure, GCP) to deploy a basic application.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 114-115: Implement CI/CD – </strong> Setup automated deployment pipelines in your cloud environment.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 116-117: Optimize the Cloud Application – </strong> Cost optimization, scaling, backup solutions.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 118: Test Day – </strong> Full Cloud Project Review.
                                        </li>
                                    </ul>
                                </div>
                            )}

                            {activeTab === 'full-stack' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Cloud Certification and Career Preparation</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 17: Certification Preparation</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 119-121: AWS Certified Solutions Architect – </strong> Associate Exam Prep.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 122-124: Microsoft Certified: Azure Fundamentals – </strong> Exam Prep.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 125-126: Google Cloud Certified – </strong> Associate Cloud Engineer Exam Prep.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 127: Test Day – </strong> Certification Exam Mock Test.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 18: Job Search Preparation</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 128-130: Resume Building – </strong> Tailor your resume for Cloud Engineering roles.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 131-133: Job Applications – </strong> Apply to Cloud Computing positions (Engineer, Architect, DevOps).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 134-135: Interview Preparation – </strong> Review Cloud-based interview questions, whiteboarding, and scenario-based questions.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 136: Test Day – </strong> Final Job Application Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 19: Mock Interviews and Job Placement</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 137-139: Mock Technical Interviews – </strong> Cloud-related technical problems.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 140-142: Soft Skills Training – </strong> Communication, Problem-solving, and Interview Etiquette.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 143-145: Real-world Scenarios – </strong> Solve cloud-based problems for mock interviews.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 146: Test Day – </strong> Final Mock Interview.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 20: Final Review and Career Transition</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 147-149: Final Review – </strong> Recap of all Cloud Concepts.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 150-152: Continue Job Search – </strong> Refine your LinkedIn, apply for jobs, and schedule interviews.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 153-154: Networking – </strong> Join Cloud Computing communities and events.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 155-156: Final Preparation – </strong> Focus on weak areas and refine your resume.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 157-158: Start your Cloud Career! – </strong> Begin your career in Cloud Computing.
                                        </li>
                                    </ul>
                                </div>


                            )}

                            {activeTab === 'interview-preparation' && (
                                <div className="container mt-4">

                                    <strong className="fw-bold fs-5 text-dark mb-2">By the end of these six months, you'll be well-prepared for both cloud computing
                                        certifications and real-world cloud roles. Best of luck in your cloud computing
                                        journey!</strong>


                                </div>

                            )}
                        </div>
                    </div>
                </div>


            </div >
        </section >
    )
}

export default InternshipCloud